/**
 * 点击组件外部时触发事件
 * v-click-outside="handleClick"
 */

export default {
    // 只调用一次，指令第一次绑定到元素时调用。在这里进行初始化设置。
    bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // 这里检查点击事件是否发生在当前元素或其子元素之外
            if (!(el === event.target || el.contains(event.target))) {
                // 如果点击发生在外部，则执行绑定的方法,如handleClick
                if (typeof binding.value === 'function') {
                    binding.value(event);
                }
            }
        };
        // 使用setTimeout延迟绑定,跳过初始点击的冒泡
        setTimeout(() => {
            document.body.addEventListener('click', el.clickOutsideEvent);
        }, 0);
    },
    // 指令与元素解绑的时候，移除事件绑定
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
        delete el.clickOutsideEvent;// 清理引用,防止内存泄漏
    }
};